module.exports = __webpack_public_path__ + "static/media/arrow-down.bd845af7.svg";